import Controller from './controller.js';
import Page from './components/page.js';

export default class App {
  constructor() {
    this.controller = new Controller();
    this.page = new Page();
  }

  start() {
    this.controller.setListeners();
    this.page.mount();
  }
}
